import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// import { User } from '../_models/index';

@Injectable()
export class UserScoreService {
    constructor(private http: HttpClient) { }

}